import { registerFormInputComponent } from '@vendure/admin-ui/core';
import { RelationCustomFieldComponent } from './input-form.component';

export default [
    registerFormInputComponent(
        'relation-custom-field',
        RelationCustomFieldComponent
    ),
];
